module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Writing a book, like enduring a disaster, requires all hands on deck")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so a warm thank-you goes out to my family, friends, and supporters who have often manned the buckets to keep this ship afloat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Additional thanks go to the editors who have previously published these works, including Nik De Dominic, Marcel Savino, W. Scott Olsen, Steven Church, Karen Craigo, Cory Aarland, Adam Kullberg, Roxane Gay, S. L. Weisenberg, Dan Wickett, Matthew Gavin Frank, Dinty W. Moore, Shena McAuliffe, Adam Weinstein, Kim Groninga, Anjali Sachdeva, Sam Martone, Jeff Albers, and Allegra Hyde.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("Thanks to Walter Font of the Allen County–Fort Wayne Historical Society for his additional fact-checking as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to my colleagues at the University of Wisconsin–Eau Claire, and in particular, Chancellor James Schmidt, Provost Patricia Kleine, President Kimera Way, Dean David Leaman, Dr. Carmen Manning, Dr. Erica Benson, Dr. Audrey Fessler, Dr. Jenny Shaddock, Dr. Justin Patchin, Dr. Jason Spraitz, Professors Max Garland, Jon Loomis, Allyson Loomis, Molly Patterson, John Hildebrand, and Karen Loeb, as well as Joanne Erickson and Vickie Schafer. I could go on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks also to my gifted graduate assistants, Alex Long, Laura Becherer, and Josh Bauer—all of whom dug deep to make this a better book—and to my undergraduate students, who make me a better writer through their own work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, thank you to Dr. Karen Havholm and the Office of Research and Sponsored Programs at the University of Wisconsin–Eau Claire, whose University Research and Creative Activity grant proved vital to this project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And, lest I forget, the Bama gang, especially those I met on the UAEDFL gridiron.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks, too, to Brendan Todt, for the edits and the correspondence, and to Jill Talbot, for the feedback that eased the doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Mom, Dad, and brother—can we consider this your Christmas present?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And to my own family, who served as witnesses to my head-pounding, hand-wringing, and tiger-pacing as I tried to tease these essays out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, thanks to all the nameless folks who didn’t just write their way out of disasters, but clawed their way out; the people who did what had to be done "), _c('em', [_vm._v("when")]), _vm._v(" it had to be done because they knew no one else was doing it.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 84
// module chunks = 0